import { AdminNewModalForm } from "./AdminNewModalForm";

const AdminNewModalFormWrapper = () => {
  return (
    <AdminNewModalForm />
  );
};

export { AdminNewModalFormWrapper };
